/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-02-27 15:12:17
 * @LastEditors: 玄离 “hongyuanzhong@cai-inc.com“
 * @LastEditTime: 2024-06-04 11:28:08
 * @Description:
 */
import { query, request } from '@/utils/request';

const urls = {
  list: '/zlb/api/pay/bank/receipt/list', // 银行回单分页搜索查询
  centerList: '/zlb/api/pay/bank/receipt/center/list', // 银行回单中心分页搜索查询
  sync: '/zlb/api/pay/bank/receipt/sync/pull', // 银行回单同步
  listByIncome: '/zlb/budget/api/income/apply-form/bank-receipt/page', // 收入银行回单
  listByIntercourseFunds: '/zlb/api/financial/intercourse/manage/bank-receipt/page', // 往来款登记银行回单
  addFinancialAccount: '/zlb/api/pay/bankCard/addFinancialAccount', // 添加财政零余额账户
};

export async function reqBankReceiptList(params) {
  return request(urls.list, { params });
}
export async function reqBankReceiptCenterList(params) {
  return request(urls.centerList, { params });
}
export async function bankReceiptSync(data) {
  return request(urls.sync, {
    method: 'POST',
    data,
  });
}

// 是否还有拉取银行回单的任务
export const checkHasTask = async () => {
  return request('/zlb/api/pay/bank/receipt/has-task');
};

export async function reqBankReceiptListByIncome(data) {
  return request(urls.listByIncome, {
    method: 'POST',
    data,
  });
}

export async function reqBankReceiptListByIntercourseFunds(data) {
  return request(urls.listByIntercourseFunds, {
    method: 'POST',
    data,
  });
}

export async function saveFinancialAccount(data) {
  return query(urls.addFinancialAccount, {
    method: 'POST',
    data,
  });
}

// 查询支付单据交易明细
export async function getOrderTradeInfo(data) {
  return query('/zlb/api/pay/order/trade/info', {
    method: 'POST',
    data,
  });
}

// 关联单据支付交易明细
export async function relationOrderTrade(data) {
  return query('/zlb/api/pay/bank/receipt/rel-order-trade', {
    method: 'POST',
    data,
  });
}

// 取消关联报销单
export async function unrelationOrderTrade(params) {
  return request('/zlb/api/pay/bank/receipt/unrel-expense-form', {
    method: 'get',
    params,
  });
}

// 取消关联凭证
export async function unrelationVoucher(params) {
  return request('/zlb/api/pay/bank/receipt/unrel-voucher', {
    method: 'get',
    params,
  });
}
